export default __webpack_public_path__ + "static/media/Group938.359add14.svg";